export class TipoBensServicos {
    idTipoBensServicos: any;
    dsTipoBensServicos: any;
    cdTipoBensServicos: any;
    
    constructor() {
        this.idTipoBensServicos = "";
        this.dsTipoBensServicos = "";
        this.cdTipoBensServicos = "";
    }
}


// WEBPACK FOOTER //
// ./src/models/TipoBensServicos.ts